import { render, staticRenderFns } from "./modalNewPartnerEntity.vue?vue&type=template&id=5dc4d7b6"
import script from "./modalNewPartnerEntity.vue?vue&type=script&lang=js"
export * from "./modalNewPartnerEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports